// extracted by mini-css-extract-plugin
module.exports = {"HeaderNavLinks":"style_HeaderNavLinks__a2Br9","active":"style_active__LZizL"};